module.exports = __webpack_public_path__ + "static/media/s_v10_34.788f58ac.mp3";